import items from "./items";

const sagas = [
  ...items
];

export default sagas;